const AUTOCOMPLETE_ATTRIBUTE_KEY = "autocompleteattr";
const BODY_TEXT_KEY = "body";
const CHECK_NEARBY_WAREHOUSES_DEVELOPMENT_KEY = "check_nearby_warehouses";
const CLOSE_BTN_ARIA_LABEL_KEY = "closebuttonarialabel";
const DRAWER_ARIA_LABEL_KEY = "drawerarialabel";
const DRAWER_FIND_BTN_LABEL_KEY = "drawerfindbuttonlabel";
const ENABLED_FEATURE_TOGGLE_CONFIG_KEY = "enabled_fulfillment_features";
const ENABLED_WAREHOUSE_LIST_CONFIG_KEY = "enabled_warehouses_list";
const ENABLED_WAREHOUSE_LIST_BOPIW_CONFIG_KEY = "enabled_warehouses_list_bopiw";
const ENABLED_WAREHOUSE_LIST_WIO_CONFIG_KEY = "enabled_warehouses_list_wio";
const FIND_A_WAREHOUSE_DEVELOPEMENT_KEY = "find_a_warehouse";
const HIDE_WAREHOUSE_FILTERS_BTN_LABEL_KEY = "hidefilteroptions";
const LIST_BOX_ARIA_LABEL_KEY = "listboxarialabel";
const LOCATION_SEARCH_PARAM_KEY = "location";
const MAX_WAREHOUSES_PER_BATCH_PROPERTY_KEY = "maxWarehousesToLazyLoad";
const OUT_OF_STOCK_ALERT_TEXT_KEY = "outofstockalert";
const POPUP_FILTER_LABEL_KEY = "popupfilterlabel";
const POPUP_FIND_BUTTON_LABEL_KEY = "popupfindbuttonlabel";
const PRODUCT_UNAVAILABLE_ALERT_TEXT_KEY = "productunavailablealert";
const RESULTS_ANNOUNCEMENT_KEY = "resultsannouncement";
const SEARCH_FAILURE_TEXT_KEY = "searchfailurecontent";
const SEARCH_FIELD_LABEL_KEY = "searchfieldlabel";
const SHOW_WAREHOUSE_FILTERS_BTN_LABEL_KEY = "showfilteroptions";
const TITLE_TEXT_KEY = "title";
const UNABLE_TO_DETERMINE_AVAILABILITY_ALERT_TEXT_KEY = "unabletodetermineavailabilityalert";
const WAREHOUSE_FILTERS_FIELDSET_KEY = "warehousefiltersfieldset";
const WAREHOUSE_PRICING_MAY_VARY_TEXT_KEY = "warehousepricingmayvary";
export {
  AUTOCOMPLETE_ATTRIBUTE_KEY,
  BODY_TEXT_KEY,
  CHECK_NEARBY_WAREHOUSES_DEVELOPMENT_KEY,
  CLOSE_BTN_ARIA_LABEL_KEY,
  DRAWER_ARIA_LABEL_KEY,
  DRAWER_FIND_BTN_LABEL_KEY,
  ENABLED_FEATURE_TOGGLE_CONFIG_KEY,
  ENABLED_WAREHOUSE_LIST_BOPIW_CONFIG_KEY,
  ENABLED_WAREHOUSE_LIST_CONFIG_KEY,
  ENABLED_WAREHOUSE_LIST_WIO_CONFIG_KEY,
  FIND_A_WAREHOUSE_DEVELOPEMENT_KEY,
  HIDE_WAREHOUSE_FILTERS_BTN_LABEL_KEY,
  LIST_BOX_ARIA_LABEL_KEY,
  LOCATION_SEARCH_PARAM_KEY,
  MAX_WAREHOUSES_PER_BATCH_PROPERTY_KEY,
  OUT_OF_STOCK_ALERT_TEXT_KEY,
  POPUP_FILTER_LABEL_KEY,
  POPUP_FIND_BUTTON_LABEL_KEY,
  PRODUCT_UNAVAILABLE_ALERT_TEXT_KEY,
  RESULTS_ANNOUNCEMENT_KEY,
  SEARCH_FAILURE_TEXT_KEY,
  SEARCH_FIELD_LABEL_KEY,
  SHOW_WAREHOUSE_FILTERS_BTN_LABEL_KEY,
  TITLE_TEXT_KEY,
  UNABLE_TO_DETERMINE_AVAILABILITY_ALERT_TEXT_KEY,
  WAREHOUSE_FILTERS_FIELDSET_KEY,
  WAREHOUSE_PRICING_MAY_VARY_TEXT_KEY
};
